// Helpers for checking RBAC permissions on the frontend.
export function hasPerm(user, module, action) {
  if (!user || !user.permissions) return false;
  const list = user.permissions[module] || [];
  return list.includes(action);
}

export function canViewAny(user, module) {
  return hasPerm(user, module, "view_all") || hasPerm(user, module, "view_own");
}

// Ordered list of (module, route) pairs the user could be sent to after login.
// Mirrors the Sidebar's main-nav order so the landing page matches the first
// item the user actually sees in the sidebar. "overview" is intentionally at
// position 0 so admins / full-access users keep their existing landing page.
const POST_LOGIN_ROUTES = [
  { module: "overview",          to: "/" },
  { module: "departments",       to: "/departments" },
  { module: "jobs",              to: "/jobs" },
  { module: "gm_view",           to: "/gm-view" },
  { module: "pm_view",           to: "/pm-view" },
  { module: "qc_pipeline",       to: "/qc-pipeline" },
  { module: "insights",          to: "/insights" },
  { module: "job_forecasting",   to: "/forecasting" },
  { module: "labor_estimation",  to: "/labor-estimation" },
  { module: "users",             to: "/users" },
  { module: "roles",             to: "/roles" },
  { module: "configuration",     to: "/configuration" },
];

/**
 * Return the first route this user can actually view. Used to land the user
 * directly on their assigned module after login (e.g. a MOLD-only user lands
 * on /departments instead of bouncing through an empty /overview).
 * Falls back to /login if the user has zero view permissions.
 */
export function firstAllowedRoute(user) {
  if (!user) return "/login";
  for (const r of POST_LOGIN_ROUTES) {
    if (canViewAny(user, r.module)) return r.to;
  }
  return "/login";
}

export const ACTIONS = ["view_all", "view_own", "create", "edit", "delete", "upload", "subscribe"];

export const ACTION_LABELS = {
  view_all: "View All",
  view_own: "View Own",
  create: "Create",
  edit: "Edit",
  delete: "Delete",
  upload: "Upload",
  subscribe: "Subscribe",
};
